import {
    UPDATE_VISUALIZER_SIZE,
    ENABLE_LISTENING_KEYBOARD_EVENTS,
    DISABLE_LISTENING_KEYBOARD_EVENTS,
} from './actions'
import { set } from 'immutadot'

const initialState = {
    size: {
        width: undefined,
        height: undefined,
    },
    listeningKeyboardEvents: true,
}

export const visualizer = (state = initialState, {type, width, height}) => {
    switch (type)
    {
        case UPDATE_VISUALIZER_SIZE:
            return set(state, 'size', { width, height })

        case ENABLE_LISTENING_KEYBOARD_EVENTS:
            return set(state, 'listeningKeyboardEvents', true)

        case DISABLE_LISTENING_KEYBOARD_EVENTS:
            return set(state, 'listeningKeyboardEvents', false)

        default:
            return state
    }
}
